<ul class="navbar-nav" *ngIf="!!currentUser">
  <li class="nav-item active">
    <a class="nav-link" routerLink="/{{NavigationRoute.LIST}}"
       data-testid="nav-list">{{ "navigationList" | localize }}</a>
  </li>
  <li class="nav-item" *ngIf="isNurseWithAllowedLocalMeasurementTypes()">
    <a class="nav-link" routerLink="/{{NavigationRoute.INITIATE_MEASUREMENT}}"
       data-testid="nav-initiate-measurement">{{ "navigationInitiateMeasurement" | localize }}</a>
  </li>
  <ng-container *ngIf="feature397Released()">
    <li
      class="nav-item"
      *ngIf="isNurseWithAllowedHomeMeasurementTypes()"
    >
      <a
        class="nav-link"
        routerLink="/{{NavigationRoute.ORDER_HOME_MEASUREMENT}}"
        data-testid="nav-order-home-measurement">
        {{ "navigationOrderHomeMeasurement" | localize }}
      </a>
    </li>
  </ng-container>
  <li class="nav-item" *ngIf="isNurseWithOperatorHospitals()">
    <a class="nav-link" routerLink="/{{NavigationRoute.ORDER_MEASUREMENT}}"
       data-testid="nav-order-measurement">{{ "navigationOrderMeasurement" | localize }}</a>
  </li>
  <li class="ms-5 my-2" *ngIf="isNurseWithAllowedLocalMeasurementTypes()">
    <span>{{ localizationKey("navigationLabelOldServiceModel") | localize }}:</span>
  </li>
  <li class="nav-item" *ngIf="isNurseWithAllowedLocalMeasurementTypes()">
    <a class="nav-link" routerLink="/{{NavigationRoute.UPLOAD}}"
       data-testid="nav-upload-measurement">{{ "navigationUpload" | localize }}</a>
  </li>
  <li class="nav-item" *ngIf="isDataOfficer()">
    <a class="nav-link" routerLink="/{{NavigationRoute.ACTIONS}}">{{ "navigationActionsLog" | localize }}</a>
  </li>
  <li class="nav-item" *ngIf="isDataOfficer()">
    <a class="nav-link" routerLink="/{{NavigationRoute.USER_LIST}}">{{ "navigationUserList" | localize }}</a>
  </li>
  <li class="nav-item" *ngIf="isDataOfficer()">
    <a class="nav-link" routerLink="/{{NavigationRoute.ADD_USERS}}">{{ "navigationAddUsers" | localize }}</a>
  </li>
  <li class="nav-item" *ngIf="isNurseWithAllowedLocalMeasurementTypes() || isDataOfficer()">
    <a class="nav-link"
       data-testid="nav-background-information"
       routerLink="/{{NavigationRoute.BACKGROUND_INFORMATION}}">{{ "navigationBackgroundInformation" | localize }}</a>
  </li>
  <li class="nav-item" *ngIf="isDataOfficer()">
    <a class="nav-link" routerLink="/{{NavigationRoute.HOSPITALS}}"
       data-testid="nav-hospitals">{{ "navigationHospitals" | localize }}</a>
  </li>
  <li class="nav-item" *ngIf="isDataOfficer()">
    <a class="nav-link" routerLink="/{{NavigationRoute.CHAINS}}"
       data-testid="nav-chains">{{ "navigationChains" | localize }}</a>
  </li>
  <li
    *ngIf="isDataOfficer() && feature533Released()"
    class="nav-item"
  >
    <a
      class="nav-link"
       data-testid="nav-generator-sentences"
      routerLink="/{{NavigationRoute.GENERATOR_SENTENCES}}"
    >{{ "navigationGeneratorSentences" | localize }}</a>
  </li>
  <li
    *ngIf="isDataOfficer()"
    class="nav-item"
  >
    <a
      class="nav-link"
       data-testid="nav-translations"
      routerLink="/{{NavigationRoute.TRANSLATIONS}}"
    >{{ "navigationTranslations" | localize }}</a>
  </li>
  <li
    *ngIf="isDataOfficer() && feature609Released()"
    class="nav-item"
  >
    <a
      class="nav-link"
      data-testid="nav-release-features"
      routerLink="/{{NavigationRoute.RELEASE_FEATURES}}"
    >{{ "navigationReleaseFeatures" | localize }}</a>
  </li>
</ul>
